import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Appp from './Appp';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import BroadcastProvider from './Providers/BroadcastProvider'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <GoogleOAuthProvider clientId="29426323371-3gpffgo18vasclrl2jifi2evd9p8chaj.apps.googleusercontent.com">
          <BroadcastProvider>
            <App />
          </BroadcastProvider>
        </GoogleOAuthProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
